<template>
  <div class="collection-tabs-container">
    <nav class="responsive-tab style-2 collection-tabs">
      <ul>
        <li v-for="tab in tabs" :key="tab.key">
          <a href="javascript:void(0)"
             :class="{ active: activeTab === tab.key }"
             @click="onTabClick(tab.key)">
            {{ tab.label }}
          </a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: "CollectionTabs",
  props: {
    activeTab: {
      type: String,
      default: 'my_collections'
    },
    tabs: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    onTabClick(key) {
      this.$emit('update:activeTab', key)
      this.$emit('tab-change', key)
    }
  }
}
</script>

<style scoped>
.collection-tabs-container {
  width: 100%;
  min-width: 0;
  overflow: hidden;
}

.collection-tabs {
  margin: 0;
  padding: 0;
}

.collection-tabs ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.collection-tabs ul li {
  display: inline-block;
}

.collection-tabs ul li a {
  display: flex;
  align-items: center;
  padding: 14px 20px;
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  text-decoration: none;
  border-bottom: 2px solid transparent;
  transition: all 0.2s ease;
  white-space: nowrap;
  cursor: pointer;
}

.collection-tabs ul li a:hover {
  color: #3e416d;
  background-color: #f8fafc;
}

.collection-tabs ul li a.active {
  color: var(--backgroundColor, #667eea);
  border-bottom-color: var(--backgroundColor, #667eea);
  font-weight: 600;
}

/* Responsive - Tablet */
@media (max-width: 959px) {
  .collection-tabs ul li a {
    padding: 12px 16px;
    font-size: 13px;
  }
}

/* Responsive - Mobile */
@media (max-width: 639px) {
  .collection-tabs ul {
    display: flex;
    gap: 8px;
    overflow-x: auto;
    padding-bottom: 4px;
    scrollbar-width: none;
    -webkit-overflow-scrolling: touch;
  }

  .collection-tabs ul::-webkit-scrollbar {
    display: none;
  }

  .collection-tabs ul li {
    flex: 0 0 auto;
  }

  .collection-tabs ul li a {
    min-height: 48px;
    box-sizing: border-box;
    padding: 12px 16px;
    font-size: 14px;
    line-height: 1.4;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
  }

  .collection-tabs ul li a.active {
    color: #fff;
    background: var(--backgroundColor, #667eea);
    border-color: var(--backgroundColor, #667eea);
  }
}
</style>
